export var basePadding = 16;
export var controlPadding = 24;
export var itemHeight = 24;
export var padding = 'var(--tabula_ui_json_view__etkwhp0)';